import React from 'react';
import ReactDOM from 'react-dom';
import { StyleRoot } from 'radium';
import { setConfiguration as setReactGridSystemConfiguration } from 'react-grid-system';
import { configure as configureLocalizationUtil } from '@vp-dst/localization-util';

import { responsiveWidthBreakpoints } from 'settings/theme';
import { activeTrackedFeatures, siteCulture } from 'settings/vistaprintContext';
import VistaprintAnalyticsService from 'services/VistaprintAnalyticsService';
import localizedTextData from 'data/localizedText.json';

import App from './App';

import 'index.css';

configureLocalizationUtil({
  siteCulture,
  localizedTextData,
});

setReactGridSystemConfiguration({
  breakpoints: responsiveWidthBreakpoints,
  containerWidths: responsiveWidthBreakpoints,
});

// records a feature value touched event for any tracked features (see data/trackedFeatures.json) that are active in the current session
activeTrackedFeatures.forEach(feature => VistaprintAnalyticsService.recordFeatureValueTouched(feature.id));

ReactDOM.render(
  <StyleRoot>
    <App />
  </StyleRoot>,
  document.getElementById('dst-ds-hub-app'),
);



// WEBPACK FOOTER //
// ./src/index.js